(function() {
    'use strict';

    angular.module('caffeprint')
        .controller('HomeController', HomeController);

    HomeController.$inject = [
        'competenceDataSrvc',
        'contactDataService',
        'userStorageSrvc',
        'checkModelPermissionsSrvc',
        'invoicePermissionsConst',
        'ksefInvoiceDataSrvc',
        'ksefInvoiceSrvc'
    ];

    function HomeController(
        competenceDataSrvc, contactDataService, userStorageSrvc, checkModelPermissionsSrvc,
        invoicePermissionsConst, ksefInvoiceDataSrvc, ksefInvoiceSrvc
    ) {
        var self = this;

        activate();

        function activate() {
            getCompetencesCount();
            getMyCompetencesCount();
            getUserx();
            checkUnsentInvoicesModal();
        }

        function getUserx() {
            self.adminName = userStorageSrvc.getUser().username;
        }

        function getCompetencesCount() {
            return contactDataService.list().$promise.then(
                function(response) {
                    self.allCompetences = response.count;
                    return response;
                }
            );
        }

        function getMyCompetencesCount() {
            return contactDataService.contactForUserCompetences().$promise.then(
                function(response) {
                    self.myCompetences = response.length;
                    return response;
                }
            );
        }

        function checkUnsentInvoicesModal() {
            const shouldShow = sessionStorage.getItem('showUnsentInvoicesModal');

            if (!shouldShow) {
                return;
            }

            sessionStorage.removeItem('showUnsentInvoicesModal');

            // The modal only leads to the invoice list - pointless without the
            // permission to open it.
            if (checkModelPermissionsSrvc.isDenied(invoicePermissionsConst.view)) {
                return;
            }

            ksefInvoiceDataSrvc.getUnsentInvoicesCount().$promise.then(function(data) {
                if (data && data.count > 0) {
                    ksefInvoiceSrvc.invoiceUnsentModal(data,
                        angular.noop,
                        angular.noop
                    );
                }
            });
        }
    }
})();
